// A phone number for display: (XXX) XXX-XXXX for a 10-digit US number (a leading 1 is
// dropped). Anything else — an extension, an international number — is shown as given.
export function formatPhoneDisplay(value) {
  if (!value) return '';
  let digits = String(value).replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) digits = digits.slice(1);
  if (digits.length !== 10) return String(value);
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}
